import { goatTestnet } from 'common-helpers/goatTestnet';
import { goatMainnet } from 'common-helpers/goatMainnet';
import { BitcoinSVG } from 'common-helpers/img';
export const ADDRESS_ZERO = '0x0000000000000000000000000000000000000000';

export enum ChainId {
    testnet = 48816,
    mainnet = 2345,
}

export const MainnetOnly = Number(process.env.REACT_APP_MAINNET_ONLY) === 1;

export const DefaultChainId = MainnetOnly ? ChainId.mainnet : ChainId.testnet;

export const SupportChainIDs = MainnetOnly ? [ChainId.mainnet] : [ChainId.mainnet, ChainId.testnet];

export const NETWORK_CONFIG = {
    [ChainId.testnet]: {
        name: goatTestnet.name,
        scanLable: 'GOAT(Testnet)-explorer',
        explore: goatTestnet.blockExplorers.default?.url,
    },
    [ChainId.mainnet]: {
        name: goatMainnet.name,
        scanLable: 'GOAT-explorer',
        explore: goatMainnet.blockExplorers.default?.url,
    },
};

export const SWITCH_NETWORK_CONFIG = {
    [ChainId.mainnet]: {
        chainId: `0x${ChainId.mainnet.toString(16)}`,
        chainName: goatMainnet.name,
        nativeCurrency: {
            name: goatMainnet.nativeCurrency.name,
            symbol: goatMainnet.nativeCurrency.symbol,
            decimals: goatMainnet.nativeCurrency.decimals,
        },
        rpcUrls: [goatMainnet.rpcUrls.default.http[0]],
        blockExplorerUrls: [goatMainnet.blockExplorers.default?.url],
    },
    [ChainId.testnet]: {
        chainId: `0x${ChainId.testnet.toString(16)}`,
        chainName: goatTestnet.name,
        nativeCurrency: {
            name: goatTestnet.nativeCurrency.name,
            symbol: goatTestnet.nativeCurrency.symbol,
            decimals: goatTestnet.nativeCurrency.decimals,
        },
        rpcUrls: [goatTestnet.rpcUrls.default.http[0]],
        blockExplorerUrls: [goatTestnet.blockExplorers.default?.url],
    },
};

export const RPC = {
    [ChainId.mainnet]: goatMainnet.rpcUrls.default.http[0],
    [ChainId.testnet]: goatTestnet.rpcUrls.default.http[0],
};

export type Token = {
    name: string;
    symbol: string;
    decimals: number;
    address: string;
    img?: string;
};

export const WalletTokenInfo = {
    [ChainId.mainnet]: [
        {
            name: 'BTC',
            logo: BitcoinSVG,
            address: '0x',
        },
        // {
        //     name: 'Ethereum',
        //     logo: ETHSVG,
        //     address: 'xxx',
        // },
    ],
    [ChainId.testnet]: [
        {
            name: 'BTC',
            logo: BitcoinSVG,
            address: '0x',
        },
        // {
        //     name: 'Ethereum',
        //     logo: ETHSVG,
        //     address: 'xxx',
        // },
    ],
};

export const ASSETS_LIST_JSON_API: string = process.env.REACT_APP_ASSETS_LIST_JSON!;
export const PARTNERS_JSON_API: string = process.env.REACT_APP_PARTNERS_JSON!;
export const BRIDGE_URL: string = process.env.REACT_APP_BRIDGE_URL!;
export const AIRDROP_URL: string = process.env.REACT_APP_AIRDROP_URL!;

// 抽奖合约地址
export const LUCKY_DRAW_CONTRACT_ADDRESS = process.env.REACT_APP_LUCKY_DRAW_CONTRACT_ADDRESS;
